import { makeAutoObservable } from "mobx";
import { changeLanguage } from "i18next";
import type { LangType } from "helpers/types";

class Store {
  loading: boolean = false;
  lang: LangType = "en";
  error: string = "";

  constructor() {
    makeAutoObservable(this);
  }

  startLoading = () => {
    this.loading = true;
  };

  endLoading = () => {
    this.loading = false;
  };

  setError = (err: string) => {
    this.error = err;
  };

  setLang = (lang: LangType) => {
    changeLanguage(lang);
    this.lang = lang;
  };
}

const globalStore = new Store();
export default globalStore;
